import { useStore } from "vuex";

export default defineNuxtRouteMiddleware((to, from) => {
	const store = useStore();

	let siteSegment;
	if (to.name === "sok" && to.query.segment) siteSegment = to.query.segment;
	else if (to.path.indexOf("/bedrift") === 0) siteSegment = "bedrift";
	else siteSegment = "privat";

	siteSegment = siteSegment.trim();

	if (siteSegment !== store.state.siteSegment) store.commit("setSiteSegment", siteSegment.trim());
});
